var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_-_map_button",
    "data-name": "icon - map button",
    transform: "translate(0.92 9.952)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "frame",
    width: 64,
    height: 64,
    transform: "translate(-0.92 -9.952)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2508",
    "data-name": "Path 2508",
    d: "M49.038,57.184c0,3.229-10.76,5.846-24.034,5.846S.97,60.413.97,57.184,11.73,51.338,25,51.338s24.034,2.617,24.034,5.846",
    transform: "translate(6.077 -9.952)",
    fill: "#ffab00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2509",
    "data-name": "Path 2509",
    d: "M25,64C12.579,64,0,61.659,0,57.184s12.579-6.815,25-6.815,25,2.341,25,6.815S37.429,64,25,64m0-11.692c-15.143,0-23.064,3.175-23.064,4.876S9.861,62.061,25,62.061s23.064-3.175,23.064-4.877S40.147,52.308,25,52.308",
    transform: "translate(6.077 -9.952)",
    fill: "#414143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2510",
    "data-name": "Path 2510",
    d: "M46.639,54.636c-.195,3.188-10.873,5.758-24.025,5.758-9.518,0-17.742-1.346-21.635-3.3,0,.029-.009.059-.009.088C.97,60.413,11.73,63.03,25,63.03s24.034-2.617,24.034-5.846c0-.913-.863-1.778-2.4-2.548",
    transform: "translate(6.077 -9.952)",
    fill: "#f59101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2511",
    "data-name": "Path 2511",
    d: "M25,64C12.579,64,0,61.659,0,57.184s12.579-6.815,25-6.815,25,2.341,25,6.815S37.429,64,25,64m0-11.692c-15.143,0-23.064,3.175-23.064,4.876S9.861,62.061,25,62.061s23.064-3.175,23.064-4.877S40.147,52.308,25,52.308",
    transform: "translate(6.077 -9.952)",
    fill: "#414143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2512",
    "data-name": "Path 2512",
    d: "M25,.97A21.322,21.322,0,0,0,3.682,22.292c0,6.656,2.488,10.393,9.168,19.269C18,48.4,22.431,54.319,24.192,56.674a1.013,1.013,0,0,0,1.624,0c1.761-2.355,6.193-8.271,11.342-15.113,6.68-8.876,9.168-12.613,9.168-19.269A21.322,21.322,0,0,0,25,.97",
    transform: "translate(6.077 -9.952)",
    fill: "#0ff497"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2513",
    "data-name": "Path 2513",
    d: "M25,58.05a1.967,1.967,0,0,1-1.588-.8c-1.761-2.353-6.192-8.27-11.341-15.11C5.583,33.516,2.712,29.4,2.712,22.291a22.292,22.292,0,0,1,44.584,0c0,7.112-2.871,11.226-9.364,19.853-5.148,6.84-9.579,12.757-11.34,15.11a1.967,1.967,0,0,1-1.588.8M25,1.939A20.375,20.375,0,0,0,4.652,22.291c0,6.238,2.192,9.676,8.972,18.687,5.151,6.842,9.584,12.76,11.345,15.114,1.831-2.354,6.264-8.272,11.414-15.115,6.781-9.01,8.973-12.447,8.973-18.686A20.375,20.375,0,0,0,25,1.939",
    transform: "translate(6.077 -9.952)",
    fill: "#414143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2514",
    "data-name": "Path 2514",
    d: "M33.643,32.338,13.881,29.562a.9.9,0,0,1-.762-1.013l2-14.223,21.536,3.027-2,14.223a.9.9,0,0,1-1.012.762",
    transform: "translate(6.077 -9.952)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2515",
    "data-name": "Path 2515",
    d: "M33.769,33.317a1.759,1.759,0,0,1-.26-.019h0L13.745,30.521a1.866,1.866,0,0,1-1.587-2.107l2-14.223a.959.959,0,0,1,1.1-.826L36.79,16.392a.969.969,0,0,1,.825,1.095l-2,14.223a1.871,1.871,0,0,1-1.847,1.607m-19.68-4.706,19.616,2.757,1.854-13.191L15.943,15.421Z",
    transform: "translate(6.077 -9.952)",
    fill: "#414143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2516",
    "data-name": "Path 2516",
    d: "M36.654,17.352,15.117,14.325l.235-1.672a.9.9,0,0,1,1.012-.763l19.762,2.778a.9.9,0,0,1,.763,1.012Z",
    transform: "translate(6.077 -9.952)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2517",
    "data-name": "Path 2517",
    d: "M36.654,18.322a1.032,1.032,0,0,1-.135-.009L14.982,15.287a.971.971,0,0,1-.825-1.1l.235-1.672A1.867,1.867,0,0,1,16.5,10.931l19.762,2.777a1.87,1.87,0,0,1,1.588,2.106l-.235,1.674a.968.968,0,0,1-.96.834M16.212,13.5l19.616,2.757.09-.639L16.3,12.861Z",
    transform: "translate(6.077 -9.952)",
    fill: "#414143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2518",
    "data-name": "Path 2518",
    d: "M35.086,28.512,26.2,27.263a.53.53,0,0,1-.451-.6l.808-5.745a.529.529,0,0,1,.6-.45l8.89,1.249Z",
    transform: "translate(6.077 -9.952)",
    fill: "#0ff497"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2519",
    "data-name": "Path 2519",
    d: "M35.086,29.481a.886.886,0,0,1-.135-.01l-8.889-1.249a1.5,1.5,0,0,1-1.277-1.693l.807-5.744a1.5,1.5,0,0,1,1.693-1.276l8.891,1.249a.971.971,0,0,1,.825,1.1l-.956,6.792a.969.969,0,0,1-.959.835m-8.319-3.118,7.493,1.053.685-4.872L27.451,21.49Z",
    transform: "translate(6.077 -9.952)",
    fill: "#414143"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckMap);
export default __webpack_public_path__ + "static/media/icon-check-map.87f44a8870e795e8fe2dc101fbc3e684.svg";
export { ForwardRef as ReactComponent };